__turbopack_context__.v({
  "badgeCorner": "GIrlBa_badgeCorner",
  "card": "GIrlBa_card",
  "date": "GIrlBa_date",
  "imageBadge": "GIrlBa_imageBadge",
  "imageWrap": "GIrlBa_imageWrap",
  "imageWrapMuted": "GIrlBa_imageWrapMuted",
  "overlay": "GIrlBa_overlay",
  "poster": "GIrlBa_poster",
  "price": "GIrlBa_price",
  "reveal-in": "GIrlBa_reveal-in",
  "stickerTopLeft": "GIrlBa_stickerTopLeft",
  "stickerTopLeftWithBadge": "GIrlBa_stickerTopLeftWithBadge",
  "title": "GIrlBa_title",
  "venue": "GIrlBa_venue",
});
